import type { ReactNode } from "react";

import { NoPermissionState } from "@/components/common/no-permission-state";
import { usePermission } from "@/hooks";
import { canOpenList, type ListKey } from "@/lib/clinic-grants";

/**
 * SEC-GATES-02: the clinic list pages and the grant each one needs. A direct
 * URL to a page outside the user's grants renders the no-permission state, not
 * an empty table, a raw 403 or a silent redirect.
 */
export const GUARDED_LIST_ROUTES = {
  "/patients": "patients",
  "/schedulings": "schedulings",
  "/financial/account": "financeAccounts",
  "/financial/account/:id/entries": "financeAccounts",
  "/financial/budgets": "budgets",
  "/financial/vouchers": "vouchers",
  "/financial/category": "categories",
  "/registrations/providers": "providers",
  "/registrations/procedures": "procedures",
  "/registrations/collaborators": "employees",
} as const satisfies Record<string, ListKey>;

export function RequireGrant({ list, children }: { list: ListKey; children: ReactNode }) {
  const { checkPermission } = usePermission();

  if (!canOpenList(checkPermission, list)) return <NoPermissionState />;

  return children;
}
